export default theme => ({
  buttonContainer: {
    display: "flex",
    gap: theme.spacing(3),
  },
  sourceThumbnail: {
    maxWidth: 500,
  },
  data: {
    marginTop: 10,
  },
  subtitle: {
    fontWeight: "initial",
    fontSize: theme.textSizes[0],
  },
  overflow: {
    overflow: "auto",
  },
  chip: {
    color: theme.palette.success.dark,
    border: `1px solid ${theme.palette.success.dark}`,
    margin: 10,
  },
  chip__activated: {
    color: theme.palette.secondary.dark,
    border: `1px solid ${theme.palette.secondary.dark}`,
  },
  chipButton: {
    display: "inline-block",
  },
  chip_secondCoach: {
    margin: 0,
    marginRight: "10px",
  },
  dataCard: {
    width: "100%",
    display: "flex",
    padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    // flexBasis: "50%",
  },
});
